"use client";

import { clientImg1, clientImg2, clientImg3, clientImg4 } from "@/assets/imgs";
import { useTranslations } from "next-intl";
import { Slider } from "./Slider";
import TestimonialCard from "./TestimonialCard";

const images = [clientImg1, clientImg2, clientImg3, clientImg4];

type Props = {
  className?: string;
};
interface Testimonial {
  name: string;
  review: string;
  role: string;
  image?: string;
}

const Testimonial = ({ className }: Props) => {
  const t = useTranslations();
  const testimonials = t.raw("testimonials.data") as Testimonial[];

  const testimonialsWithImages = Array.isArray(testimonials)
    ? testimonials.map((tItem, i) => ({
        ...tItem,
        image: images[i % images.length],
      }))
    : [];

  return (
    <div className={`${className} flex flex-col gap-20`}>
      <div className="flex flex-col items-center gap-10 text-white">
        <p className="text-md uppercase">{t("homePage.testimonial")}</p>
        <h3 className="text-center text-4xl font-bold">
          {t("homePage.whatSayingOurCustomers")}
        </h3>
      </div>

      <Slider
      showDots
        slides={testimonialsWithImages.map((testimonial) => (
          <div className=" pb-28 pt-2 sm:pb-32 " key={testimonial.name}>
            <TestimonialCard
              feedback={testimonial.review}
              img={testimonial.image}
              name={testimonial.name}
            />
          </div>
        ))}
        breakpoints={{
          768: 2,
          375: 1,
        }}
      />
    </div>
  );
};

export default Testimonial;
